import { render, staticRenderFns } from "./GoodsOdoList.vue?vue&type=template&id=4bc44c42&"
import script from "./GoodsOdoList.vue?vue&type=script&lang=js&"
export * from "./GoodsOdoList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsOdoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoodsOdoItem: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdoItem.vue').default})
